module.exports = __webpack_public_path__ + "static/media/logo-image.0c978c0a.png";